import React, { useContext, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import ControlButtonClose from './ControlButtonClose';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlItem from './ControlItem';
import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';
import SuccessAlert from './SuccessAlert';

import ModalRequirementsUpdate from './ModalRequirementsUpdate';
import ModalItemsDelete from './ModalItemsDelete';

import MyRequirementsContext from '../context/RequirementsContext';
import MyProceduresContext from '../context/ProceduresContext';

export const cutSpaces = (text) => {
    return text.replace(/\n{3,}/, '\n\n').replace(/ +/g, ' ');
}

const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}

const ControlRequirements = ({ setActive, name, redirect }) => {
    const{requirements, loading, error, addRequirement, setRequirement, deleteRequirement} = useContext(MyRequirementsContext);
    const{procedure} = useContext(MyProceduresContext);

    const[itemId, setItemId] = useState(null);
    const[isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const[isModalRequirementsUpdateOpen, setIsModalRequirementsUpdateOpen] = useState(false);
    const[localError, setLocalError] = useState({ "error": false, "message": "" });
    const[successAlert, setSuccessAlert] = useState(null);

    const schema = yup.object().shape({
        requirementTitle: yup.string().required("El titulo es requerido").max(120, "El titulo no puede tener más de 60 caracteres").min(1, "El titulo no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        requirementDescription: yup.string().required("La descripción es requerida").max(640, "La descripcion no puede tener mas de 640 caracteres").min(5, "La descripción no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue))
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await addRequirement(data, procedure.procedureId)
        if (res.error) {
            setLocalError({ "error": true, "message": res.response })
            setTimeout(() => {
                setLocalError({ "error": false, "message": "" })
            }, 3000);
        } else {
            reset()
            setLocalError({ "error": false, "message": "" })
            setSuccessAlert("Documento agregado correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }

    return (
        <div className='animation-appear-right-center'>
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteRequirement} itemId={itemId} />
            <ModalRequirementsUpdate isModalRequirementsUpdateOpen={isModalRequirementsUpdateOpen} setIsModalRequirementsUpdateOpen={setIsModalRequirementsUpdateOpen} setSuccessAlert={setSuccessAlert} itemId={itemId} />
            <SuccessAlert isVisible={successAlert} />
            <div className='flex flex-col'>
                <ControlButtonClose onClick={() => setActive(redirect)} />
                <h1 className='text-center my-4'>
                    AGREGAR DOCUMENTO
                </h1>
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
                    <div className="grid grid-cols-2 gap-6">
                        <div className="relative z-0 w-full group">
                            <input type="text" {...register("requirementTitle")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Titulo*</label>
                            <ErrorWrapper error={errors.requirementTitle?.message} />
                        </div>
                        <div className="relative z-0 mb-4 w-full group">
                            <input type="text" {...register("requirementDescription")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Descripción*</label>
                            <ErrorWrapper error={errors.requirementDescription?.message} />
                        </div>
                    </div>
                    <div className='text-center flex mb-2 mx-auto'>
                        {localError.error && <ErrorWrapper error={localError.message} />}
                    </div>
                    <div className='flex flex-col w-[50%] mx-auto'>
                        {loading ? <Loading isLoading={true} /> : <button type="submit" className=" mx-auto bg-gray-300 border shadow hover:text-white hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center duration-300 w-full">Agregar Documento</button>}
                    </div>
                </form>

                <h1 className='mt-4'>
                    Documentos necesarios para el {name + " " + procedure.procedureTitle}:
                </h1>
                {error.error && <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1>}
                {requirements && requirements.length > 0 ? requirements.map((requirement, index) => (
                    <ControlItem key={index} title={requirement.requirementTitle} text={requirement.requirementDescription}>
                        <ControlButtonUpdate onClick={()=>{setRequirement(requirement);setItemId(requirement.requirementId + ";" + procedure.procedureId); setIsModalRequirementsUpdateOpen(true)}} />
                        <ControlButtonDelete onClick={()=>{setItemId(requirement.requirementId + ";" + procedure.procedureId); setIsModalItemsDeleteOpen(true)}} />
                    </ControlItem>
                )):<h1 className='w-full font-light my-4'>Este {name} no tiene documentos asignados.</h1>}
                <div>
                    <Loading isLoading={loading} />
                </div>
            </div>
        </div>
    );
}

export default ControlRequirements;